import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

import { TimeFormat } from '@enums/timeFormat.enum';

dayjs.extend(duration);
dayjs.extend(relativeTime);

export const dayDurationHumanize = (duration: number): string => {
	if (duration > 60 && duration < 3600) {
		const minutes = Math.ceil(duration / 60);
		return `${minutes} ${TimeFormat.Minutes}`;
	}
	return dayjs.duration(duration, TimeFormat.Seconds).humanize();
};
